"use client";

import React from "react";
import { Phone, Mail, Instagram, MapPin, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const contactMethods = [{
  id: "phone",
  title: "Telefon",
  value: "+385 91 650 9999",
  link: "tel:+385916500999",
  icon: Phone,
  description: "Ponedjeljak - Petak: 08:00 - 16:00"
}, {
  id: "email",
  title: "E-pošta",
  value: "privatnost@tvrtka.hr",
  link: "mailto:privatnost@tvrtka.hr",
  icon: Mail,
  description: "Odgovaramo u roku od 24 sata"
}, {
  id: "instagram",
  title: "Društvene mreže",
  value: "@tvrtka_hrvatska",
  link: "https://instagram.com",
  icon: Instagram,
  description: "Pratite naše službene objave",
  newTab: true
}];
export default function OurStudio() {
  return <section data-section-id="233944" id="kontakt" className="bg-background text-foreground py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-default text-primary text-base/7 font-semibold tracking-wide uppercase">
            Kontaktirajte nas
          </h2>
          <p className="font-default text-foreground mt-2 text-4xl font-medium tracking-tight sm:text-5xl">
            Pitanja o privatnosti
          </p>
          <p className="text-muted-foreground mt-6 text-lg/8 font-default">
            Imate li pitanja o zaštiti vaših osobnih podataka ili želite podnijeti zahtjev vezan uz vašu privatnost? Naš tim za usklađenost stoji vam na raspolaganju za sve upite.
          </p>
        </div>

        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-6 sm:mt-20 lg:max-w-none lg:grid-cols-3">
          {contactMethods.map((method, i) => {
          const Icon = method.icon;
          return <Card key={method.id} data-index={i} className="group relative overflow-hidden border-border/50 bg-card/50 backdrop-blur-sm transition-all hover:border-secondary/50 hover:shadow-lg">
                <CardHeader className="pb-4">
                  <div className="mb-4 flex justify-center">
                    {}
                    <div className="relative flex size-16 items-center justify-center">
                      <div className="absolute inset-0 rotate-45 rounded-lg border-2 border-secondary/20 bg-secondary/5 transition-transform duration-500 group-hover:rotate-90 group-hover:border-secondary/40 group-hover:bg-secondary/10" />
                      <Icon className="text-primary relative z-10 size-6 transition-transform duration-500 group-hover:scale-110" />
                    </div>
                  </div>
                  <CardTitle className="font-default text-foreground text-center text-xl">
                    {method.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center">
                  <Link to={method.link} newTab={method.newTab} className="font-default text-primary hover:text-secondary inline-block text-lg font-medium transition-colors">
                    {method.value}
                  </Link>
                  <CardDescription className="mt-2 font-default text-muted-foreground text-base">
                    {method.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="mt-16 sm:mt-24">
          <div className="relative h-[400px] w-full overflow-hidden rounded-lg border border-border/50 shadow-md sm:h-[500px]">
            {}
            <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/zagreb_office_location_map.png)] bg-cover bg-center bg-no-repeat" />
            
            {}
            <div className="absolute inset-0 bg-primary/5 mix-blend-multiply" />
            <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-background/20 to-transparent" />

            {}
            <Card className="absolute bottom-6 left-6 right-6 max-w-sm border-border/50 bg-background/95 backdrop-blur-md sm:bottom-10 sm:left-10 sm:right-auto shadow-xl">
              <CardHeader className="pb-2">
                <CardTitle className="font-default flex items-center gap-2 text-lg text-foreground">
                  <MapPin className="text-secondary size-5" />
                  Sjedište tvrtke
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-foreground font-default text-base">Augusta Cesarca 6, 10412 Velika Gorica, Hrvatska</p>
                <div className="text-muted-foreground mt-4 flex items-center gap-2 font-default text-sm">
                  <Clock className="size-4" />
                  <span>Radno vrijeme: Pon - Pet 08:00 - 16:00</span>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}